<template>
  <Content :button-create-show="true">
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
        :method-delete-row="methods.deleteRow"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";

import { getCities as fetchData, deleteCity as deleteRow } from "@/api/cities";

const columnsOptions = {
  sortable: "custom",
  controls: true,
  id: "id",
  edit: true,
  delete_row: {
    buttonName: "Удалить",
  },
};

const columns = [
  {
    prop: "id",
    label: "ID",
    width: 50,
  },
  {
    prop: "name",
    label: "Название города",
  },
  {
    prop: "code",
    label: "Код для поиска",
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: columnsOptions,
      columns: columns,
      methods: {
        fetchData,
        deleteRow,
      },
    };
  },
};
</script>
